import React from "react"
import Link from "gatsby-link"

export default class Page extends React.Component {
  componentDidMount(){
    const postId = Math.floor(Math.random() * ((this.props.data.allAirtable.edges.length-1) - 0 + 1)) + 0;
    window.setTimeout(() => {
      window.location.href = `/${this.props.data.allAirtable.edges[postId].node.fields.slug}`
    }, 600)
  }

  render() {
    return (
      <div id="container" className="flex-container">
        <h1 id="title" className='flex-item loading'>
          <span className="suffix">What's Bert Doing? </span>
        </h1>
      </div>
    )
  }
}

export const query = graphql`
  query IndexQuery {
    allAirtable {
      edges {
        node {
          fields {
            slug
          }
       }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js